import { _, vue, mergeAppStartOptions, ZPage, ZPageRuntime, AppStartOptions } from '@zto/zpage'

import { ZPageElementUI } from '@zto/zpage-ui-element'

import * as TuxiOperateWebBase from './TuxiOperateWebBase'

import { envMap } from './env'
import configs from './config'
import apis from './apis'
import { HOST_APP_ZCAT_KEY } from './consts'

import { extensions } from './extensions'
import { components } from './components'
import { widgets } from './widgets'

import { getCurrentEnvFromEnvMap, reportTraceData } from './utils'

import type { KtAppStartOptions } from './typings'

/** 启动应用 */
export async function startOperateApp(options: KtAppStartOptions) {
  // 支持微应用全局变量
  if (!window.Vue) window.Vue = vue
  if (!window.ZPage) window.ZPage = ZPage
  if (!window.ZPageRuntime) window.ZPageRuntime = ZPageRuntime
  if (!window.ZPageElementUI) window.ZPageElementUI = ZPageElementUI
  if (!window.TuxiOperateWebBase) window.TuxiOperateWebBase = TuxiOperateWebBase

  // zcat init
  if (options.isZcat) options.initTrace = zcatInit

  const startOptions = getAppStartOptions(options)

  // 处理配置
  if (options.beforeStart) options.beforeStart(startOptions, options)

  // 启动应用
  const app = await ZPage.startApp(startOptions)

  // // 启动应用后， 监听埋点事件，上传数据
  // if (options.isZcat) appOnTrace(app)

  return app
}

/** 获取应用配置 */
export function getAppStartOptions(options: KtAppStartOptions) {
  const opts = _.omit(options, ['beforeStart', 'config', 'envMap'])
  opts.container = options.container || `#${options.name}`

  const appConfigs = [{ apis, ...configs }, { ...options.config }]

  const mergedEnvMap = _.deepMerge(envMap, options.envMap)

  let _env: any | null = {}

  if (options.env?.name) {
    _env = mergedEnvMap[options.env?.name]?.ENV
  } else {
    _env = getCurrentEnvFromEnvMap(mergedEnvMap)
  }

  opts.env = _.deepMerge({}, _env, options.env)

  opts.pages = opts.pages || []

  // 默认附加welcome页面
  if (!opts.pages.some((page: any) => page.path === '/welcome')) {
    opts.pages.push({ path: '/welcome', type: 'welcome' })
  }

  const mergedOptions = mergeAppStartOptions(
    {
      ui: { ...ZPageElementUI },
      extensions: { components, widgets, ...extensions }
    },
    opts
  )

  mergedOptions.configs = appConfigs

  return mergedOptions
}

/**
 * zcat init
 * @param app
 * @param options
 */
export function zcatInit(app: any, options: AppStartOptions) {
  console.log('当前zcat环境===', options?.env?.isProdZcat)
  console.log('当前zcat的appKey===', options?.env?.appKeyZcat || HOST_APP_ZCAT_KEY)

  // mergeOptions不需要在传入app key
  window.zcat.mergeOptions({
    isProd: ['kt.tuxi.com', 'kt.txyypt.re.ztosys.com'].includes(window.location.hostname),
    trace: [/tuxi-operate.gw-test.ztosys.com/, /tuxi-operate.gw.zt-express.com/]
  })

  window.zcat.init({
    appKey: options?.env?.appKeyZcat || HOST_APP_ZCAT_KEY, // 应用的唯一标识
    vue: app.vueApp, // vue2项目需要将Vue构造函数传入, vue3项目需要将Vue示例传入
    isProd: options?.env?.isProdZcat || false // 为true时，数据将上报至zcat的生产环境，设为false时，数据上报至zcat的测试环境。
  })

  // 监听埋点事件，上传数据
  appOnTrace(app)
}

/**
 * 监听埋点事件
 * @param app
 */
export function appOnTrace(app: any) {
  // 监听埋点事件，上传数据
  app.ons('trace', (e: any) => {
    setTimeout(() => {
      reportTraceData(app, e)
    }, 100)
  })
}
